import { useState, useCallback } from "react";
import { CategoryButton } from "../types/categories";
import { categoryService } from "./categoryService";

export const useCategories = () => {
  const [categories, setCategories] = useState<CategoryButton[]>([]);
  const [loading, setLoading] = useState(false);
  const [totalRecords, setTotalRecords] = useState(0);
  const [error, setError] = useState<string | null>(null);

  const fetchCategories = useCallback(async (showDeleted: boolean, page: number, pageSize: number, searchTerm: string = "") => {
    setLoading(true);
    try {
      const data = await categoryService.fetch(showDeleted, page, pageSize, searchTerm);
      setCategories(data.categoryDetails);
      setTotalRecords(data.totalRecords);
    } catch (err) {
      setError("Failed to fetch categories");
      console.error(err);
    } finally {
      setLoading(false);
    }
  }, []);

  return { categories, loading, totalRecords, error, fetchCategories, setCategories };
};
